import { useContext } from 'react';
import { PlanContext } from './PlanProvider';
import type { PlanState } from './types';

/**
 * What the active organization's plan allows.
 *
 * Throws outside the provider rather than defaulting to the free tier: a
 * missing provider would otherwise surface as mysteriously tight limits instead
 * of a clear error, which is the same reasoning `useGridConfig` uses.
 */
export function usePlan(): PlanState {
  const state = useContext(PlanContext);
  if (!state) throw new Error('usePlan must be used inside <PlanProvider>');
  return state;
}

/**
 * One ceiling, or `null` for unlimited. A thin wrapper on purpose — callers
 * that read a limit should not also have to know how the state is shaped.
 */
export function useModuleLimit(moduleKey: string, key: string): number | null {
  return usePlan().limit(moduleKey, key);
}

/** Whether the plan includes the module at all. */
export function useHasModule(moduleKey: string): boolean {
  return usePlan().hasModule(moduleKey);
}
